<template>
  <div class="footer">
    <p class="footer_recommend">
      推荐产品：
      <a href="https://eshop.dellemc-solution.com/workstation" target="_blank">戴尔工作站</a>
      <a href="https://www.dellemc-solution.com/services" target="_blank">戴尔咨询服务</a>
      <a href="https://eshop.dellemc-solution.com/N302L3330-D1506FCN_VP" target="_blank">Latitude 3330</a>
      <a href="https://eshop.dellemc-solution.com/N303L5430-D1526FCN_VP" target="_blank">Latitude 5430</a>
      <a href="https://eshop.dellemc-solution.com/N301L9430-D1506FCN_VP" target="_blank">Latitude 9430</a>
      <a href="https://eshop.dellemc-solution.com/N002O7000T-D1515CN_VP" target="_blank">OptiPlex 7000</a>
      <a href="https://eshop.dellemc-solution.com/N001O7400AIO-D1515CN_VP" target="_blank">OptiPlex 7400 AIO</a>
      <a href="https://eshop.dellemc-solution.com/storage" target="_blank">戴尔数据存储</a>
      <a href="https://eshop.dellemc-solution.com/promo-fwsc3260_vp" target="_blank">Precision 3260</a>
      <a href="https://eshop.dellemc-solution.com/promo-mws5570-i912900h-online_vp" target="_blank">Precision 5570</a>
      <a href="https://eshop.dellemc-solution.com/promo-mws5770-i712800h-online_vp" target="_blank">Precision 5770</a>
    </p>
    <div class="bottom-logo-model">
      <img src="../assets/images/foot_logo.webp" alt="Dell">
    </div>
    <p class="topInfoAll" :style="{ height: infoHeight }">
      本条款和条件（以下简称“商业销售条款”）适用于由客户（同意从戴尔购买产品、软件和/或服务并写在戴尔报价单或发票中的法人）（以下简称“客户”）或代表客户仅为内部使用而非转售目的，直接从注册地址位于中国福建省厦门市金尚路 2388 号的戴尔（中国）有限公司（以下简称“戴尔”）购买的所有产品、软件和/或服务，并排除其他所有条款和条件的适用。本商业销售条款及戴尔的订单文件和服务文件（定义见下文）在客户和戴尔之间形成了购买产品、软件和服务的具有法律约束力的合同（以下简称“协议”）。如果客户与戴尔为购买产品、软件或服务订立了一份单独的协议，则该的单独协议连同相关订单文件和服务文件（如果存在）应替代本商业销售条款适用。客户承认其知晓本商业销售条款的内容，并同意遵守本商业销售条款。无论戴尔承认采购订单或未反对采购订单中冲突的、不同的或附加的条款和条件均不能被认定为接受该等条款和条件或放弃其中的规定。除非戴尔已用确认订单和/或由戴尔向客户发出描述客户按照协议购买的产品、软件和/或服务的发票的方式接受客户订单，否则将认为协议不成立。除非戴尔以书面形式明确表示同意和接受，否则销售的产品、软件和/或提供的服务均适用该协议，并排除其他任何由客户规定或提出的条款和条件。各协议文件适用以下优先顺序：（1）订单文件；（2）服务文件和（3）本商业销售条款。
    </p>
    <div class="topInfoAllOpen" v-if="openButShow" @click="openInfo"><i class=" el-icon-d-arrow-left"></i></div>
    <div class="topInfoAllOpen" v-if="closeButShow" @click="colseInfo"><i class=" el-icon-d-arrow-right"></i></div>
    <div class="line"></div>
    <div class="bottomInfo">
      <div class="bottomInfo-text">
        <span>*戴尔仅在符合相关法律法规及
        <a href="https://www.dell.com/learn/cn/zh/cncorp1/policies-privacy" target="_blank" class="color-dell">隐私声明</a>
        和
        <a href="https://www.dell.com/learn/cn/zh/cncorp1/terms-of-sale?s=corp" target="_blank" class="color-dell">销售条款</a>
        下收集与使用客户访问信息。<br>
        <span class="footer-company-info">
          北京优奥创思科技发展有限公司<br>
          地址：北京市朝阳区高井文化园路8号东亿国际传媒产业园区三期4层402<br>
          注：北京优奥创思科技发展有限公司为戴尔（中国）有限公司指定平台服务商
        </span>
      </span>
        <span class="mar-t-10">请浏览以下网站获得更多信息
        <a target="_blank" href="https://www.dell.com/learn/cn/zh/cncorp1/solutions/art-important-dell-detail-cn?c=cn&amp;l=zh&amp;s=corp&amp;redirect=1" class="color-dell">www.dell.com.cn/product_information</a>
      </span>
        <span>
        <a href="https://eshop.dellemc-solution.com/business-license" target="_blank" rel="noopener"> 增值电信业务许可证：京B2-20202426</a>
      </span>
        <span>版权：©2018-2022 Dell Inc.&thinsp;版权所有
        <img src="../assets/images/guohui.webp" class="guohui">
        <a class="beian" target="_blank" href="http://beian.miit.gov.cn">京ICP备11038982号-18</a>
      </span>
      </div>
      <div class="bottom-logo">
        <img src="../assets/images/foot_logo.webp" alt="Dell">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return{
      infoHeight: 'auto',
      openButShow: false,
      closeButShow: false
    }
  },
  mounted() {
    if(this.$store.state.isMobile){
      this.infoHeight = '149px';
      this.openButShow =  true;
      this.closeButShow = false;
    }else{
      this.infoHeight = 'auto';
      this.openButShow =  false;
      this.closeButShow = false;
    }
  },
  methods: {
    openInfo() {
      this.infoHeight = "auto";
      this.openButShow = false;
      this.closeButShow = true;
    },
    colseInfo() {
      this.infoHeight = "149px";
      this.openButShow = true;
      this.closeButShow = false;
    }
  }
}
</script>

<style scoped lang="less">
  @media (min-width: 992px){
    .footer{
      display: block;
      background: #fff;
      font-size: 14px;
      line-height: 22px;
      color: gray;
      padding: 30px 130px;
      .bottom-logo-model{
        display: none;
      }
      .topInfoAllOpen{
        display: none;
      }
      p{
        padding: 0 90px 10px;
        a{
          color: gray;
          padding: 0 4px;
        }
      }
      .line{
        width: 100%;
        height: 1px;
        background: #ededed;
      }
      .footPesonal{
        margin-bottom: 6px;
      }
      .bottomInfo{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding-bottom: 30px;
        .bottomInfo-text{
          padding-left: 90px;
          span{
            display: block;
            a{
              color: gray;
            }
          }
        }
        .bottom-logo{
          display: block;
          width: 375px;
          img{
            width: 260px;
          }
        }
      }
    }
  }
  @media (max-width: 992px) {
    .footer{
      background: #EDEDED;
      font-size: 20px;
      line-height: 36px;
      color: #808080;
      /*padding-bottom: 30px;*/
      .topInfoAll{
        padding: 40px;
        overflow: hidden;
      }
      .bottom-logo-model{
        text-align: center;
        padding-top: 36px;
        img{
          width: 400px;
          height: auto;
        }
      }
      .topInfoAllOpen{
        text-align: center;
        i{
          font-size: 40px;
          transform: rotate(-90deg);
        }
      }
      .footer_recommend{
        display: none;
      }
      .bottom-logo{
        display: none;
      }
      .bottomInfo{
        background: #444;
        color: #aaa;
        padding: 40px 40px 40px 90px;
        span{
          display: block;
          a{
            color: #aaa;
            &.color-dell{
              color: #009AE3;
            }
          }
        }
      }
    }
  }
</style>
